<template>
  <div class="modal fade slide-up" :id="modalId" role="dialog" aria-hidden="false">
    <div class="modal-dialog">
      <div class="modal-content-wrapper">
        <div class="modal-content">

          <form @submit.prevent="onValidate">
            <div class="modal-body pb-1">
              <div v-for="(userEntity, index) in userEntitiesData" :key="userEntity.entity.id">
                <div class="checkbox">
                  <input type="checkbox"
                         :id="`checkbox_${index}`"
                         v-model="userEntity.selected"
                         :disabled="userEntity.alreadyRegistered"/>
                  <label :for="`checkbox_${index}`">{{ userEntity.entity.name }}</label>

                  <div v-if="userEntity.alreadyRegistered"
                       :key="'notification_' + index">
                    {{ $t('CandidateSelectEntitiesModal.already_registered') }}
                  </div>
                </div>

                <div v-if="showEntityForm(userEntity)">
                  <candidate-entity-form :userEntity="userEntity"
                                         :manageableOptions="optionsFor(userEntity)"
                                         @change="onChange" />
                </div>
              </div>
            </div>

            <hr>

            <div class="modal-footer mt-10">
              <div class="col-md-6 text-left">
                <button type="button"
                        class="btn btn-default btn-cons"
                        aria-label="Close"
                        @click="dismiss">
                  {{ $t("buttons.cancel") }}
                </button>
              </div>
              <div class="col-md-6 text-right">
                <button type="submit"
                        class="btn btn-primary btn-cons"
                        >
                  {{ $t("buttons.validate") }}
                </button>
              </div>
            </div>
          </form>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CandidateEntityForm from './CandidateEntityForm'
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  name: 'CandidateSelectEntitiesModal',
  props: ['userEntities', 'allManageableOptions', 'modalId'],
  components: {
    CandidateEntityForm
  },
  data() {
    return {
      userEntitiesData: []
    }
  },
  computed: {
    ...mapGetters({
      currentUser: 'auth/currentUser'
    })
  },
  methods: {
    formId(userEntity) {
      return `form_${userEntity.entity.id}`
    },
    initUserEntitiesData() {
      this.userEntitiesData = _.cloneDeep(this.userEntities);
    },
    optionsFor(userEntity) {
      return this.allManageableOptions[userEntity.entity.id]
    },
    showEntityForm(userEntity) {
      return !userEntity.alreadyRegistered && userEntity.selected;
    },
    onChange(value) {
      const index = this.findUserEntityIndex(value.entityId);
      const userEntitiesData = _.cloneDeep(this.userEntitiesData);
      userEntitiesData[index][value.field] = value.data;

      this.userEntitiesData = userEntitiesData;
    },
    findUserEntityIndex(entityId) {
      return this.userEntitiesData.findIndex(element => element.entity.id === entityId);
    },
    onValidate() {
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          this.$emit('validate', this.userEntitiesData);
          this.dismiss();
        }
      });
    },
    dismiss() {
      $(`#${this.modalId}`).modal('hide');
    }
  },
  watch: {
    userEntities() {
      this.initUserEntitiesData();
    }
  }
}
</script>

<style lang="scss" scoped>
  hr {
    width: 90%;
    height: 2px;
    color: rgba(0, 0, 0, 0.07);
  }
  .checkbox {
    input[type=checkbox]:checked + label:before {
      border-color: #e51349;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/entities/CandidateSelectEntitiesModal.vue